// The bakery crawl routes — shared by /bakeries and /bakery-crawl, and route 1
// is mirrored in the planner as the BAKERY_WALK one-tap day (Feb–Mar).
// img: real user photos where we have them. coords feed the page route maps.
const SITE = "https://cphhighlights.com";

// Route 1 — the classic: Østerbro first, then down through the cobbled centre
// to the Latin Quarter. About 6 km end to end.
export const BAKERY_CRAWL_ROUTE = [
  { name: "Bosses Bager", street: "Østerbrogade 132", coords: [55.70616, 12.5777], img: "/planner/90a6d4e6491f.webp" },
  { name: "Juno the Bakery", street: "Århusgade 48", coords: [55.70616, 12.58169], img: "https://images.pexels.com/photos/38354165/pexels-photo-38354165.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Det Rene Brød", street: "Rosenvængets Allé 17", coords: [55.704, 12.5767], img: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/jn21spnj_2026-09-28%2022_20_25.023%2B0200.webp" },
  { name: "Buka", street: "Store Kongensgade 18", coords: [55.681, 12.587] },
  { name: "Andersen & Maillard", street: "Ny Østergade 15", coords: [55.6803, 12.5835], img: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/01zbyst0_2026-09-28%2022_18_28.336%2B0200.webp" },
  { name: "Hart Bageri", street: "Gammel Mønt 4", coords: [55.683, 12.5783] },
  { name: "La Glace", street: "Skoubogade 3", coords: [55.6786, 12.5735], img: "/planner/d42dfee2df14.webp" },
  { name: "Sankt Peders Bageri", street: "Sankt Peders Stræde 29", coords: [55.67913, 12.56921], img: "https://images.pexels.com/photos/38354172/pexels-photo-38354172.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

// Route 2 — the neighbourhoods: Carlsberg Byen and Vesterbro,
// over the harbour to Islands Brygge and Amager, ending out on Refshaleøen.
// About 14 km by bike — honestly better by bike.
export const BAKERY_CRAWL_ROUTE_2 = [
  { name: "Københavns Bageri", street: "Flaskehalsen 22", coords: [55.6648, 12.5355] },
  { name: "Bageriet BRØD", street: "Enghave Plads 7", coords: [55.6669, 12.5469] },
  { name: "Better Bakery", street: "Helgolandsgade 10", coords: [55.67, 12.5571] },
  { name: "Andersen Bakery", street: "Thorshavnsgade 26", coords: [55.6669, 12.576] },
  { name: "Alice", street: "Markmandsgade 1", coords: [55.6628, 12.5835] },
  { name: "Eriks Bageri", street: "Amagerbrogade 176", coords: [55.6562, 12.601], img: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/vmxj1k7o_20260926_181621.webp" },
  { name: "Lille Bakery", street: "Refshalevej 213A", coords: [55.693, 12.611] },
];

const crawlQ = (s) => encodeURIComponent(`${s.name}, ${s.street}, Copenhagen`);

export const bakeryCrawlUrl = (stops) =>
  `https://www.google.com/maps/dir/?api=1&origin=${crawlQ(stops[0])}&destination=${crawlQ(stops[stops.length - 1])}&waypoints=${stops.slice(1, -1).map(crawlQ).join("%7C")}&travelmode=walking`;

const crawlItemList = (route, name, description) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name,
  description,
  itemListElement: route.map((s, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: `${s.name}, ${s.street}, Copenhagen`,
    url: `${SITE}/bakery-crawl`,
  })),
});

export const BAKERY_CRAWL_ITEMLIST = crawlItemList(
  BAKERY_CRAWL_ROUTE,
  "The Copenhagen bakery crawl — a ready-made walking route",
  "One walk, eight bakeries: one address per brand, ordered for the shortest sensible route — Østerbro through the city centre to the Latin Quarter. About 6 km."
);

export const BAKERY_CRAWL_ITEMLIST_2 = crawlItemList(
  BAKERY_CRAWL_ROUTE_2,
  "The Copenhagen neighbourhood bakery crawl — the longer route",
  "Seven more bakeries through Carlsberg Byen, Vesterbro, Islands Brygge and Amager, ending on Refshaleøen. About 14 km — best by bike."
);
